import {lazy, type ComponentType} from 'react'

type ImportFn = () => Promise<{default: ComponentType<any>}>

/**
 * Lazy route with a simple retry on chunk load failure (network blips).
 */
export function lazyRoute(importFn: ImportFn) {
  return lazy(async () => {
    try {
      return await importFn()
    } catch {
      await new Promise((r) => setTimeout(r, 200))
      return importFn()
    }
  })
}
